import React from 'react'
import {Icon} from '@chakra-ui/react'

const LeftIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props} aria-hidden="true">
            <path
                id="arrow"
                d="M22.0001 11.4999H4.41012L6.70012 9.20995C7.09012 8.81995 7.09012 8.18995 6.70012 7.79995C6.31012 7.40995 5.68012 7.40995 5.29012 7.79995L1.29012 11.7899C1.20012 11.8799 1.12012 11.9899 1.07012 12.1199C0.970117 12.3599 0.970117 12.6399 1.07012 12.8799C1.12012 12.9999 1.19012 13.1099 1.29012 13.2099L5.29012 17.2099C5.49012 17.4099 5.74012 17.4999 6.00012 17.4999C6.26012 17.4999 6.51012 17.3999 6.71012 17.2099C7.10012 16.8199 7.10012 16.1899 6.71012 15.7999L4.42012 13.5099H22.0101C22.5601 13.5099 23.0101 13.0599 23.0101 12.5099C23.0101 11.9599 22.5601 11.5099 22.0101 11.5099L22.0001 11.4999Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default LeftIcon
